import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import AppItem from './app-item';

var AppList = function AppList(_ref) {
  var t = _ref.t,
      ns = _ref.ns,
      apps = _ref.apps,
      consents = _ref.consents,
      onToggle = _ref.onToggle;
  return React.createElement("ul", {
    className: ns('AppList')
  }, apps.map(function (app) {
    var checked = consents[app.name];

    var handleToggle = function handleToggle(value) {
      return onToggle(app, value);
    };

    return React.createElement("li", {
      key: "app-".concat(app.name),
      className: ns("AppList-item AppList-item--".concat(app.name))
    }, React.createElement(AppItem, _extends({
      checked: checked || app.required,
      onToggle: handleToggle,
      t: t,
      ns: ns
    }, app)));
  }));
};

export default AppList;